import { render, staticRenderFns } from "./CustomersWalletBanner.vue?vue&type=template&id=768f1842&scoped=true"
import script from "./CustomersWalletBanner.vue?vue&type=script&lang=js"
export * from "./CustomersWalletBanner.vue?vue&type=script&lang=js"
import style0 from "./CustomersWalletBanner.vue?vue&type=style&index=0&id=768f1842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768f1842",
  null
  
)

export default component.exports